/* MAYIILANG : protection ciblée des photographies produits/créations contre
   l'enregistrement direct. Agit sur le contenu de <main> (fiches produit,
   collections, sections et carrousels de la page d'accueil) ET sur la
   fenêtre de zoom photo (<product-modal>) et l'aperçu rapide
   (<quick-add-modal>), que le thème Dawn déplace hors de <main> au
   chargement. Jamais sur l'en-tête ou le pied de page (logo, icônes de
   navigation, panier, réseaux sociaux), afin de ne pas bloquer
   inutilement le clic droit sur l'ensemble du site.

   Empêche : le menu contextuel ("Enregistrer l'image sous...", "Copier
   l'image") et le glisser-déposer des photos. Ne touche ni au zoom
   produit, ni à la navigation, ni à l'accessibilité (aucun élément
   interactif désactivé).

   Limite connue, assumée : ceci dissuade la sauvegarde occasionnelle (clic
   droit, glisser-déposer, appui long sur mobile) mais ne peut pas empêcher
   une personne déterminée d'utiliser les outils de développement ou une
   capture d'écran : aucune protection côté navigateur ne peut bloquer
   cela techniquement. */
(function () {
  var PROTECTED_SELECTOR =
    'main img, main picture, ' +
    'product-modal img, product-modal picture, ' +
    'quick-add-modal img, quick-add-modal picture';

  function isProtected(target) {
    return !!(target && target.closest && target.closest(PROTECTED_SELECTOR));
  }

  document.addEventListener('contextmenu', function (event) {
    if (isProtected(event.target)) event.preventDefault();
  });

  document.addEventListener('dragstart', function (event) {
    if (isProtected(event.target)) event.preventDefault();
  });
})();
